import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const CustomShowLoader = ({ size, color }) => {
  return <CircularProgress color="inherit" size={size} />;
};

export default CustomShowLoader;
